import React, { Component, useState, useEffect, useContext } from 'react';
import { TabItem, TabList } from '../../controls';
import { CustomerUsers } from '../';
import CustomerCodingProfile from './CustomerAccount/CustomerCodingProfile';
import CustomerAccountClinicians from './CustomerAccount/CustomerAccountClinicians';
import FormControls, { ConditionalRender } from '../../controls/formControls';
import { LinkContainer } from 'react-router-bootstrap';
import { Card, Button, Form, Col, Tabs, Tab, ButtonToolbar, Dropdown, ToggleButton, ButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faChevronCircleRight, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { userTypes } from '../../utilities/appConstants';
import { CustomerAccountService } from '../../services';

const ParentCustomerAccountDetails = (props) => {
    const showModal = props.showModal;
    const closeModal = props.closeModal;
    const notifyUserChange = props.notifyUserChange;
    const customer = props.customer;

    useEffect(() => {
        // get list of customers here or in modal?
    }, [])

    const confirmAccountRemoval = (account) => {
        //  confirm removal with modal
        showModal({
            open: true,
            closeModal: closeModal,
            confirm: () => removeChildAccount(account.id),
            title: "Confirm account link deletion",
            message: `Are you sure you want to remove ${account.name} as a child account of ${customer.name}?`
        }, 'confirmModal')
    }

    const removeChildAccount = async (id) => {
        const service = new CustomerAccountService();
        var result = await service.removeLinkedAccount(customer.id, id);
        if (result.result) {
            // add account to list
            props.removeChildAccount(id);
        } else {
            // show error modal
            showModal({
                open: true,
                hideModal: closeModal,
                title: "Error",
                message: result.message
            }, 'errorModal')
        }

        //save modal
        closeModal();
    }

    const linkChildAccount = async (account) => {
        const service = new CustomerAccountService();
        var result = await service.linkAccount(customer.id, account.id);
        if (result.result) {
            // add account to list
            props.addChildAccount({ "id": account.id, "name": account.name });
        } else {
            // show error modal
            showModal({
                open: true,
                hideModal: closeModal,
                title: "Error",
                message: result.message
            }, 'errorModal')
        }

        //save modal
        closeModal();
    }

    var users = customer.users?.filter(x => { return x.userType === userTypes.customerUser });
    users = users ? users : [];

    return (
        <TabList>
            <TabItem label="Users" isTable>
                <CustomerUsers users={users} userType={userTypes.customerUser} accountId={customer.id} showModal={showModal} closeModal={closeModal} notifyUserChange={notifyUserChange} />
            </TabItem>
            <TabItem label="Child Accounts" isTable>
                <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th className="table-fit">Id</th>
                            <th>Account Name</th>
                            <th>Type</th>
                            <th className="table-fit">
                                <Button variant="primary" size="sm" onClick={() => showModal({
                                    open: true,
                                    closeModal: closeModal,
                                    linkChildAccount: linkChildAccount
                                }, 'addChildAccount')}>Link</Button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {customer.childAccounts.map((account) =>
                            <tr key={account.id} >
                                <td className="table-fit">{account.id}</td>
                                <td>{account.name}</td>
                                <td>Child Account</td>
                                <td className="table-fit">
                                    <FontAwesomeIcon icon={faTimesCircle} className="danger-icon" onClick={() => confirmAccountRemoval(account)} />&nbsp;
                                    <LinkContainer to={'/admin/accounts/' + account.id}>
                                        <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
                                    </LinkContainer>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </TabItem >
        </TabList >
    );
}


const CustomerAccountDetails = (props) => {
    const showModal = props.showModal;
    const closeModal = props.closeModal;
    const notifyUserChange = props.notifyUserChange;
    const customer = props.customer;
    const formik = props.formik;
    const updateClinician = props.updateClinician;
    const getContactInfo = props.getContactInfo;

    var users = customer.users?.filter(x => { return x.userType === userTypes.customerUser });
    users = users ? users : [];
    var contacts = customer.users?.filter(x => { return x.userType === userTypes.contact });
    contacts = contacts ? contacts : [];

    return (
        <TabList>
            <TabItem label="Coding Profile">
                <CustomerCodingProfile formHandler={formik} contacts={customer.users} />
            </TabItem>
            <TabItem label="Misc/Notes">
                <Form.Row>
                    <Form.Group as={Col} lg="3" md="6">
                        <FormControls.DropdownDisplayList
                            label="User account request contact"
                            name="userAccountRequestContactId"
                            variant="secondary"
                            formHandler={formik}
                            valueField="id"
                            displaySelected={(opt) => getContactInfo(opt?.id, customer.users)}
                            displayOption={(values) => (<>{values.fullName} <br /> {values.emailAddres}</>)}
                            options={customer.users} />
                    </Form.Group>
                    <ConditionalRender visible={formik.values.emrVendorId === 4}>
                        <Form.Group as={Col} lg="3" md="6">
                            <FormControls.Textbox
                                label="Groundcontrol code (BT Only)"
                                name="groundControlCode"
                                formHandler={formik} />
                        </Form.Group>
                    </ConditionalRender>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} lg="8" md="12">
                        <FormControls.Textarea
                            label="Shared login info"
                            name="sharedLoginInfo"
                            rows="3"
                            formHandler={formik} />
                    </Form.Group>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.Textarea
                            label="Misc / Additional Notes"
                            name="miscNotes"
                            rows="4"
                            formHandler={formik} />
                    </Form.Group>
                </Form.Row>
            </TabItem>
            <TabItem label="Contacts" isTable hidden={users.length > 0}>
                <CustomerUsers users={contacts} userType={userTypes.contact} accountId={customer.id} showModal={showModal} closeModal={closeModal} notifyUserChange={notifyUserChange} />
            </TabItem>            
            <TabItem label="Users" isTable hidden={users.length === 0}>
                <CustomerUsers users={users} userType={userTypes.customerUser} accountId={customer.id} showModal={showModal} closeModal={closeModal} notifyUserChange={notifyUserChange} />
            </TabItem>
            <TabItem label="Clinicians" isTable>
                <CustomerAccountClinicians clinicians={customer.clinicians} tenantId={customer.id} showModal={showModal} closeModal={closeModal} updateClinician={updateClinician} />
            </TabItem>
        </TabList>
    );
}


export { ParentCustomerAccountDetails, CustomerAccountDetails };